import Modal from 'react-bootstrap/Modal';
import './CookiesPolicyModal.css';

interface CookiesPolicyModalProps {
  show: boolean;
  onHide: () => void;
}

function CookiesPolicyModal({ show, onHide }: CookiesPolicyModalProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      scrollable
      aria-labelledby="footer-cookie-modal-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="footer-cookie-modal-title">Cookies Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body id="cookiePolicyContent">
        <div className="cookie-policy-content">
          <section className="cookie-category">
            <h2 className="h5 mb-2 cookie-title">1. Background</h2>
            <p>
              Cookies are small text files containing a random and unique identifier that are
              downloaded to your device by websites you visit. They are widely used in order to
              make websites work, or work more efficiently, as well as to provide information to
              the owners of the website.
            </p>
            <p>We use different types of cookies for different things, such as:</p>
            <ul>
              <li>To help you use the aosphere.com website;</li>
              <li>Analysing how you use the aosphere.com website; and</li>
              <li>Analysing the effectiveness of our content.</li>
            </ul>
          </section>

          <section className="cookie-category">
            <h2 className="h5 mb-2 cookie-title">2. Your choices</h2>
            <p>
              We use &quot;Necessary&quot; cookies on this website. They are essential for core
              functionality such as page navigation and site performance, security, verification of
              identity and network management and we collect your IP address to use these cookies.
              We have listed them, what they are used for and how long they are retained below. Our
              lawful bases for this processing of your data are &quot;contract fulfilment&quot; and
              &quot;legitimate interests&quot;. Necessary cookies cannot be disabled using the
              cookie preferences tool.
            </p>
            <p>
              We also use &quot;Analytical&quot; (&quot;Statistical&quot;) cookies on this website
              to gather aggregated, non-personal data that helps us analyse and improve our
              website. This includes insights into user numbers, time spent on specific pages, and
              navigation patterns. These cookies are enabled by default but can be turned off using
              the toggle switch.
            </p>
            <p>
              We would like to use optional &quot;Functionality&quot; and &quot;Other third-party&quot;
              cookies, listed and described below, but only if you give us your permission to do so
              by consenting. They are all disabled as the default. To consent, slide the button
              from &quot;off&quot; to &quot;on&quot; and enable your selection, or click the
              &quot;I Accept All Cookies&quot; button to accept all the cookies. You can change your
              cookies preferences at any time by clicking on the &quot;C&quot; icon in the bottom
              right corner of our website.
            </p>
            <p>
              You may also visit the third-party sites and follow the instructions in their cookie
              notices; or, you may disable them by changing your cookie settings in your browser as
              described below.
            </p>
          </section>

          <section className="cookie-category">
            <h2 className="h5 mb-2 cookie-title">3. Necessary cookies</h2>
            <p>
              These cookies are necessary to enable core functionality, such as accessibility, and
              to enable us to keep track of your cookie choices.
            </p>
            <div className="table-responsive">
              <table className="cookie-table table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: '33%' }}>Cookie name</th>
                    <th style={{ width: '33%' }}>Purpose</th>
                    <th style={{ width: '33%' }}>Expiry</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <code>JSESSIONID</code>
                    </td>
                    <td>
                      This cookie is used for session management purposes. A unique identifier is
                      created at the start of each user&apos;s session and deleted when the browser
                      is closed.
                    </td>
                    <td>When you close your browser session.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="cookie-category">
            <h2 className="h5 mb-2 cookie-title">4. Functionality cookies</h2>
            <p>
              These cookies enable functionality that remembers choices you have made on the
              website. If you disable these cookies it may interfere with your experience on our
              website.
            </p>
            <div className="table-responsive">
              <table className="cookie-table table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: '33%' }}>Cookie name</th>
                    <th style={{ width: '33%' }}>Purpose</th>
                    <th style={{ width: '33%' }}>Expiry</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <code>EID</code>
                    </td>
                    <td>
                      If a user selects the &quot;Remember me&quot; checkbox, a cookie will be
                      saved on the user&apos;s computer to allow the user to login automatically on
                      subsequent visits to the site.
                    </td>
                    <td>1 month</td>
                  </tr>
                  <tr>
                    <td>
                      <code>EP</code>
                    </td>
                    <td>
                      These cookies are used to store the logged-in user&apos;s email id/password in
                      encrypted text. This is used to streamline the login process by automatically
                      identifying the user the next time they access the system from the same
                      computer.
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <strong>For auto login users accessing aoslogin via a third party API:</strong>
                      <br />
                      <code>ECV</code>
                      <br />
                      <code>EVK</code>
                      <br />
                      <code>EUK</code>
                    </td>
                    <td>
                      These cookies are used to store:
                      <br />
                      ECV: the encrypted text to control the captcha for API autologin
                      <br />
                      EVK: the encrypted vendor key for the &quot;Remember me&quot; function
                      <br />
                      EUK: the encrypted vendor user key for the &quot;Remember me&quot; function.
                    </td>
                    <td>
                      ECV: 1 day.
                      <br />
                      EVK: 1 month.
                      <br />
                      EUK: 1 month.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="cookie-category">
            <h2 className="h5 mb-2 cookie-title">5. Analytics cookies</h2>
            <p>
              These help us to improve our website by collecting and reporting information on how
              you use it.
            </p>
            <div className="table-responsive">
              <table className="cookie-table table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: '33%' }}>Cookie name</th>
                    <th style={{ width: '33%' }}>Purpose</th>
                    <th style={{ width: '33%' }}>Expiry</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Universal Analytics (Google):</strong>
                      <br />
                      <code>_gcl_au</code>
                      <br />
                      <code>_ncuid</code>
                      <br />
                      <code>IDE</code>
                      <br />
                      <code>test_cookie</code>
                      <br />
                      <code>posthog/hotjar</code>
                    </td>
                    <td>
                      These cookies are used to collect information about how visitors use our
                      website, and for advertising analytics purposes. They distinguish users on the
                      website by assigning a randomly generated number as an identifier. The user
                      data provided to aosphere is aggregated and therefore anonymous.
                    </td>
                    <td>
                      _gcl_au: 3 months.
                      <br />
                      _ncuid: 1 year.
                      <br />
                      IDE: 1 year.
                      <br />
                      test_cookie: 1 day.
                      <br />
                      posthog/hotjar: 3 months.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="cookie-category">
            <h2 className="h5 mb-2 cookie-title">6. Other third-party cookies</h2>
            <p>
              These cookies are set by websites other than www.aoslogin.com (e.g. when you access
              content on our website that is hosted on a third-party site).
            </p>
            <div className="table-responsive">
              <table className="cookie-table table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: '33%' }}>Cookie name</th>
                    <th style={{ width: '33%' }}>Purpose</th>
                    <th style={{ width: '33%' }}>Expiry</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Civic UK Cookie control:</strong>
                      <br />
                      <code>CookieControl</code>
                    </td>
                    <td>
                      This cookie is used to remember a user&apos;s choice about cookies on our
                      website. Where users have previously indicated a preference, that user&apos;s
                      preference will be stored in this cookie.
                    </td>
                    <td>3 months.</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Neota Logic:</strong>
                      <br />
                      <code>side wide</code>
                    </td>
                    <td>
                      Used by Neota Logic to store a web session ID/token identifying the user&apos;s
                      login session.
                    </td>
                    <td>When you close your browser session.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="cookie-category">
            <h2 className="h5 mb-2 cookie-title">7. Changing cookie settings in your browser</h2>
            <p>
              For information on how to disable and/or clear cookies, including third-party
              cookies, on your device please follow the instructions in the links below:
            </p>
            <ul className="browser-list">
              <li>
                <a
                  href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                  target="_blank"
                  rel="noreferrer"
                >
                  Microsoft Edge
                </a>
              </li>
              <li>
                <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">
                  Google Chrome
                </a>
              </li>
              <li>
                <a
                  href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                  target="_blank"
                  rel="noreferrer"
                >
                  Safari (desktop)
                </a>
              </li>
              <li>
                <a href="https://support.apple.com/en-us/HT201265" target="_blank" rel="noreferrer">
                  Safari (mobile)
                </a>
              </li>
              <li>
                <a
                  href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox"
                  target="_blank"
                  rel="noreferrer"
                >
                  Firefox
                </a>
              </li>
              <li>
                <a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank" rel="noreferrer">
                  Opera
                </a>
              </li>
              <li>
                <a href="https://www.netscape.com" target="_blank" rel="noreferrer">
                  Netscape
                </a>
              </li>
            </ul>
            <p>
              More information on managing your cookie settings can be found at{' '}
              <a href="https://www.allaboutcookies.org" target="_blank" rel="noreferrer">
                www.allaboutcookies.org
              </a>
              {'.'}
            </p>
          </section>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CookiesPolicyModal;
